/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { Collapse, Form, OverlayTrigger, Tooltip, Image } from 'react-bootstrap';
import DataTableFilter from "../../Common/DataTableFilter";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector } from "react-redux";
import { WebSocketContext } from "../../../App";
import CommonDateTime from "../../Common/CommonDateTime";
import SendMailModal from "../../Common/SendMailModal";
import CommonTable from "../../Common/CommonTable";
import CommonDatePicker from "../../Common/CommonDatePicker";
import CommonReactSelectMenu from "../../Common/CommonReactSelectMenu";
import ExportToCSV from "../../Common/ExportToCSV";
import ExelIcon from "../../../assets/img/XLS_icon.svg";

const ErpStockReport = (props) => {
    const { websocket } = useContext(WebSocketContext);
    const { selfInfo, device_id, storedDetailsReportList, wareHouselistall, productlistall } = useSelector((state) => state.adminReducers);
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ selectWarehouseBike, setselectWarehouseBike ] = useState("");
    const [ selectProductBike, setselectProductBike ] = useState("");
    const [ FilterOpen, setFilterOpen ] = useState(false);
    const [ FromEndDate, setFromEndDate ] = useState([null, null]);
    const [ FromDate, ToDate ] = FromEndDate;
    const optionsWarehouse = wareHouselistall?.filter((elm) => elm?.is_active === true)?.map((item, index) => ({ key: item.id, value: item?.id, label: `${item?.warehouse_name} (${item?.warehouse_code}) - (${item?.display_name})` }));
    const optionsProducts = productlistall?.map((item, index) => ({ key: item.id, value: item?.id, label: item?.product_name }));
    const PermissionsAccess = selfInfo?.user?.permissions_access;
    const [ sendEmailModal, setsendEmailModal ] = useState({
        open: false,
        title: ""
    });

    // get all city list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[6]?.Edit || PermissionsAccess?.Store[6]?.View)) {
            let param = {
                "transmit": "broadcast",
                "url": "product_list",
                "request": {
                    "status": true,
                    "limit": 5000,
                    "page_no": 1,
                    "search": ""
                },
                "DeviceId": device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // get all city list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[6]?.Edit || PermissionsAccess?.Store[6]?.View)) {
            let param = {
                "transmit": "broadcast",
                "url": "warehouse_list",
                "request": {
                    "status": "",
                    "limit": 5000,
                    "page_no": 1,
                    "search": ""
                },
                "DeviceId": device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // get product list
    useEffect(() => {
        if (websocket) {
            callPayloadReport(currentPage);
        }
    }, [websocket, userSearch, userType, currentPage, userLimit, selectWarehouseBike, selectProductBike, ToDate]);

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    const callPayloadReport = (currentPage) => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Store[6]?.Edit || PermissionsAccess?.Store[6]?.View)) {
            let param = {
                "transmit": "broadcast",
                "url": "erp_store_frame_list",
                "request": {
                    "status": userType,
                    "limit": userLimit,
                    "page_no": currentPage,
                    "search": userSearch.trim(),
                    "from_date": null,
                    "to_date": null,
                    "warehouse_id": selectWarehouseBike?.value,
                    "product_id": selectProductBike?.value,
                },
                "DeviceId": device_id
            };
            if (FromDate !== "" && ToDate !== "") {
                param.request.from_date = CommonDateTime(FromDate, "YYYY-MM-DD", "hide");
                param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
            };
            wsSend_request(websocket, param);
        };
    };

    // send email function
    const SendEmailFunction = () => {
        setsendEmailModal({
            ...sendEmailModal,
            open: !sendEmailModal?.open,
            title: "Send Mail"
        });
    };

    // E-BIKE TABLE COLUMNS ARRAY
    const BikeTableColumns = [
        { key: 'updated_at', label: 'Updated On', type: "date_time", sort: "", isCollapsable: false },
        { key: 'frame_number', label: 'Frame Number', type: "label", sort: "", isCollapsable: false },
        { key: 'warehouse_name', label: 'Warehouse Name', type: "label", sort: "", isCollapsable: false },
        { key: 'created_at', label: 'Added On', type: "date", sort: "", isCollapsable: false },
        // { key: 'order_at', label: 'Sold On', type: "date", sort: "", isCollapsable: false },
        { key: 'order_code', label: 'Order No', type: "label", sort: "", isCollapsable: false },
        { key: 'status', label: 'Status', type: "status_sold_unsold", sort: "", isCollapsable: false },
    ];

    return (<section className="Main_section StockDetailsReportPage">
        <div className="filtr_Form" style={{ borderBottom: "1px solid #eee" }}>
            <div className="formloginset">
                <div className="row">
                    <div className="col-md-3">
                        <CommonDatePicker 
                            dateRange={FromEndDate} 
                            setDateRange={setFromEndDate}
                            placeholderText={"Select From Date & To Date"}
                            dependantState={{
                                allow: true,
                                statType: "current_page",
                                stateFunction: setCurrentPage
                            }} 
                            daysValidation={"15"}
                        />
                    </div>
                    <div className="col-md-3">
                        <Form.Group className="mb-3" >
                            <CommonReactSelectMenu 
                                label={"Warehouse"}
                                options={optionsWarehouse} 
                                selectValue={selectWarehouseBike} 
                                setSelectValue={setselectWarehouseBike} 
                                dependantState={{
                                    allow: true,
                                    statType: "current_page",
                                    stateFunction: setCurrentPage
                                }} 
                                isMendatory={false}
                                isAllowClearable={true}
                                customWidth={"100%"}
                                customeHeight={"38px"}
                                isMulti={false}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-md-3">
                        <Form.Group className="mb-3" id="mb-3">
                            <CommonReactSelectMenu 
                                label={"Product"}
                                options={optionsProducts}
                                selectValue={selectProductBike} 
                                setSelectValue={setselectProductBike} 
                                dependantState={{
                                    allow: true,
                                    statType: "current_page",
                                    stateFunction: setCurrentPage
                                }} 
                                isMendatory={false}
                                isAllowClearable={true}
                                customWidth={"100%"}
                                customeHeight={"38px"}
                                isMulti={false}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-md-3" id="erp-stock-report-btn-group">
                        <Form.Group className="mb-3" id="mb-3" style={{ display: "flex", justifyContent: "flex-start",columnGap: "10px" }}>
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 100 }}
                                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                                    {FilterOpen ? "Filter Hide" : "Filter Show"}
                                </Tooltip>}
                            >
                                <button
                                    className="filtercollapsebtn"
                                    onClick={() => setFilterOpen(!FilterOpen)}
                                    aria-controls="example-collapse-text"
                                    aria-expanded={FilterOpen}
                                >
                                    {FilterOpen ? (<i className="bi bi-funnel-fill"></i>) : (<i className="bi bi-funnel"></i>)} Filter
                                </button>
                            </OverlayTrigger>
                            {(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.StockDetailsReportSendMailActive) && (<OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 100 }}
                                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                                    Send ERP Stock Report via Email.
                                </Tooltip>}
                            >
                                <button type="button" className="btn exportbtn" onClick={() => SendEmailFunction()}>
                                    <i className="bi bi-envelope-at" style={{ margin: "0px" }}></i>
                                </button>
                            </OverlayTrigger>)}
                            <button 
                                className="btn exportbtn" 
                                id="stocklevelExportbtn" 
                                onClick={() => ExportToCSV("Erp-Stock-Report-List")}
                            >
                                <Image src={ExelIcon} alt="excel" />
                            </button>
                        </Form.Group>
                    </div>
                </div>
            </div>
            <Collapse in={FilterOpen}>
                <div className="formloginset">
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Group className="mb-3" id="mb-3">
                                <select className="form-control" value={userType} onChange={(e) => { setUserType(e?.target?.value); setCurrentPage(1) }}>
                                    <option value="">Select Status</option>
                                    <option value="SOLD">Sold</option>
                                    <option value="UNSOLD">Un-Sold</option>
                                </select>
                            </Form.Group>
                        </div>
                    </div>
                </div>
            </Collapse>
        </div>
        <div className="filter_stock_inward">
            <DataTableFilter
                filterType={"Frame Number"}
                searchType={"Frame Number, Order No"}
                userSearch={userSearch}
                setUserSearch={setUserSearch}
                userLimit={userLimit}
                setUserLimit={setUserLimit}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                buttonvisible={false}
                searchdisable={true}
                ActiveInactiveFilter={false}
            />
        </div>
        <div className="tableView">
            <CommonTable 
                isTableAllow={true}
                style={{
                    height: FilterOpen === true ?
                        parseInt(storedDetailsReportList?.pagination?.total_records) === storedDetailsReportList?.list?.length ? "calc(100vh - 255px)" : parseInt(storedDetailsReportList?.pagination?.total_records) > 10 ? "calc(100vh - 290px)" : "calc(100vh - 255px)" :
                        parseInt(storedDetailsReportList?.pagination?.total_records) === storedDetailsReportList?.list?.length ? "calc(100vh - 210px)" : parseInt(storedDetailsReportList?.pagination?.total_records) > 10 ? "calc(100vh - 245px)" : "calc(100vh - 210px)"
                }}
                srNumber={{
                    clickable: false,
                    events: ""
                }}
                isCollapsable={false}
                tabName={"Erp-Stock-Report-List"} // TAB URL
                PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
                PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
                TableColumns={BikeTableColumns} // TABLE COLLUMNS & ROWS
                OrderList={storedDetailsReportList} // PRODUCT LIST
                Pagination={storedDetailsReportList?.pagination} // CURRENT TAB PAGINATION
                EditAccess={false} // EDITABLE ACCESS STATE
                isActionColumnAvailable={{
                    isShow: false,
                    label: "",
                    naviagte: null
                }}
                isActionTwoColumnAvailable={{
                    isShow: false,
                    url: "",
                }}
                isOdiFilterRowColorsAllow={false}
            />
        </div>
        
        {/* send mail for Stock Details Report modal */}
        {sendEmailModal?.open && (<SendMailModal sendEmailModal={sendEmailModal} setsendEmailModal={setsendEmailModal} />)}
    </section>)
}

export default ErpStockReport;